// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2f7YF","title":"Header_title__DHlpc","left":"Header_left__2-y4y","clinicName":"Header_clinicName__axyKl"};